// ES dictionary: one JSON file per client-facing namespace, merged
// here so both Deno (edge functions) and Vite (frontend) import the same
// files. Namespaces are disjoint on purpose — each extraction surface owns
// exactly one, so parallel branches never collide on a key.
import common from './common.json' with { type: 'json' };
import pdf from './pdf.json' with { type: 'json' };
import email from './email.json' with { type: 'json' };
import proposal from './proposal.json' with { type: 'json' };
import esign from './esign.json' with { type: 'json' };
import invoice from './invoice.json' with { type: 'json' };
import pay from './pay.json' with { type: 'json' };
import portal from './portal.json' with { type: 'json' };
import lead from './lead.json' with { type: 'json' };
import mockup from './mockup.json' with { type: 'json' };
import doordrop from './doordrop.json' with { type: 'json' };
import contract from './contract.json' with { type: 'json' };
import signoff from './signoff.json' with { type: 'json' };

export const es = {
  common, pdf, email, proposal, esign, invoice, pay, portal, lead, mockup, doordrop, contract, signoff,
};
